import React from "react";
import '../SbtierCSS/SbtierCarrer.css';
import Typography from "@mui/material/Typography";
import useDocumentMeta from "../hooks/useDocumentMeta";

const workWithUsPoints = [
    {
        tag: "// TECHNOLOGY",
        title: "Innovate at the Forefront of Technology",
        text: "You'll work on projects that push the limits of what's possible in semiconductor design and development. From AI and machine learning to IoT and automotive applications, your work will contribute to the technologies of tomorrow.",
    },
    {
        tag: "// CULTURE",
        title: "Collaborative and Inclusive Environment",
        text: "We believe that great ideas come from diverse perspectives. Our culture fosters collaboration across teams and disciplines, ensuring that every voice is heard.",
    },
    {
        tag: "// GROWTH",
        title: "Opportunities for Growth",
        text: "Whether you're just starting your career or are an experienced professional, you'll find opportunities to grow your skills, take on new challenges, and advance.",
    },
    {
        tag: "// IMPACT",
        title: "Make a Real Impact",
        text: "As a startup, every team member plays a critical role in our success. You'll see your work come to life in real products across automotive, telecommunications, healthcare, and more.",
    },
    {
        tag: "// TEAM",
        title: "Work with the Best",
        text: "Our team is made up of top-tier engineers and professionals who are passionate about what they do, committed to excellence in every field.",
    },
];

const lookingForPoints = [
    { title: "Problem Solvers", text: "You thrive on tackling complex challenges and finding innovative solutions." },
    { title: "Collaborators", text: "You enjoy working with diverse teams to bring ideas to life." },
    { title: "Visionaries", text: "You have a forward-thinking mindset and are excited about shaping the future of technology." },
    { title: "Detail-Oriented", text: "You take pride in producing precise, high-quality work, even in fast-paced environments." },
    { title: "Lifelong Learners", text: "You're always looking to learn new skills and grow professionally." },
];

const openPositions = [
    "Semiconductor Design Engineer",
    "Embedded Systems Engineer",
    "Software Engineer (Firmware)",
    "SoC Architect",
    "Verification & Validation Engineer",
    "Product Manager",
    "Manufacturing Engineer",
];

function SbtierCareer(){
    useDocumentMeta(
        "Careers",
        "Join SatyaBalTech Semiconductor. We're hiring semiconductor design engineers, embedded systems engineers, SoC architects, and more."
    );

    return (
        <div className="sbtier-career-container">
            {/* career section*/}
            <div className="sbtier-career-section" style={{backgroundImage:'url("/images/sbsi_background_1.png")'}}>
                <div className="hero-overlay" />
                <div className="hero-inner">
                    <span className="hero-eyebrow">Careers</span>
                    <Typography variant="h3" component="h3" className="career-title">
                        Careers at SatyaBalTech Semiconductor: Shape the Future of Technology with Us
                    </Typography>
                    <Typography variant="body1" className="career-text">
                        At SatyaBalTech semiconductor, we’re not just building semiconductor solutions—we’re creating
                        the technology that will drive the next generation of innovation. If you’re passionate
                        about pushing boundaries, solving complex problems, and making an impact on a global scale,
                        you’ll fit right in here. We are a dynamic, fast-growing company driven by the belief that
                        the best ideas come from the brightest minds.
                    </Typography>
                </div>
            </div>
            {/* work with us section*/}
            <div className="sbtier-career-workWithUs-section">
                <Typography variant="h3" component="h3">
                    Why Work with Us?
                </Typography>
                <div className="work-with-us-grid">
                    <div className="work-with-us-image">
                        <img src="images/career_work_with_us.webp" alt="Working at SatyaBalTech Semiconductor"/>
                    </div>
                    <div className="work-with-us-cards">
                        {workWithUsPoints.map((point) => (
                            <div className="work-with-us-card" key={point.title}>
                                <span className="work-with-us-card-tag">{point.tag}</span>
                                <h4>{point.title}</h4>
                                <p>{point.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Looking for section*/}
            <div className="sbtier-career-lookingFor-section">
                <Typography variant="h3" component="h3">
                    Who We’re Looking For
                </Typography>
                <Typography variant="body1" className="looking-for-text">
                    We are seeking talented, driven individuals who are excited about the future of semiconductor
                    technology. Whether you’re an experienced engineer, a recent graduate, or a professional from
                    another field looking to make a career shift, we value your passion, creativity, and commitment
                    to innovation. Our ideal candidates are:
                </Typography>
                <div className="looking-for-grid">
                    {lookingForPoints.map((point) => (
                        <div className="looking-for-card" key={point.title}>
                            <h4>{point.title}</h4>
                            <p>{point.text}</p>
                        </div>
                    ))}
                </div>
            </div>
            {/* Open position & join-us section*/}
            <div className="position-join-container">
                <div className="sbtier-career-OpenPosition-section">
                    <Typography variant="h3" component="h3">
                        Open Positions
                    </Typography>
                    <Typography variant="body1" className="open-position-text">
                        We are currently hiring for the following positions:
                    </Typography>
                    <div className="open-position-tags">
                        {openPositions.map((position) => (
                            <span className="open-position-tag" key={position}>{position}</span>
                        ))}
                    </div>
                    <Typography variant="body1" className="open-position-text">
                        If you’re ready to take your career to the next level and be a part of something big,
                        we want to hear from you. Even if you don’t see a position that matches your exact skill
                        set, we encourage you to reach out—at SatyaBalTech Semiconductor, we’re always on the lookout
                        for top talent.
                    </Typography>
                </div>
                <div className="sbtier-career-joinUs-section">
                    <Typography variant="h3" component="h3">
                        Join Us and Make an Impact
                    </Typography>
                    <Typography variant="body1" className="join-us-text">
                        At SatyaBalTech semiconductor, we’re more than just a workplace. We are a community of
                        innovators, engineers, and dreamers working together to build the future of technology.
                        If you’re ready to be part of something exciting, challenging, and rewarding, we invite you to
                        explore career opportunities with us.
                    </Typography>
                </div>
            </div>
            <div className="sbtier-career-statement-section">
                <p className="career-statement">
                    Explore open positions and apply today at SatyaBalTech Semiconductor. Let’s create the future
                    of semiconductor technology together.
                </p>
            </div>
        </div>
    );
}

export default SbtierCareer;